const frCommon = {
    // Actions and words that show up on more than one screen
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    close: "Fermer",
    clear: "Vider",
    retry: "Réessayer",
    signIn: "Se connecter",
    signOut: "Se déconnecter",
    createAccount: "Créer un compte",
    unknownErrorMessage: "Une erreur est survenue, merci de réessayer",
    languageLabel: "Langue",
    languageFrench: "Français",
    languageEnglish: "English",

    // Error pages
    notFoundTitle: "Page introuvable",
    notFoundDescription: "Cette page n'existe pas ou a été déplacée. Vérifiez l'adresse, ou revenez à l'accueil.",
    serverErrorTitle: "Une erreur est survenue",
    serverErrorDescription: "Une erreur inattendue a empêché le chargement de cette page. Rechargez-la, et si le problème persiste, réessayez plus tard.",
    reloadPage: "Recharger",
    backHome: "Retour à l'accueil",

    // Navigation
    navMatches: "Matchs",
    navCompetitions: "Compétitions",
    navHistory: "Historique",
    navPricing: "Formules",

    // Competitions screen
    competitionsTitle: "Compétitions",
    competitionsSubtitle: "Choisissez une compétition et analysez n’importe lequel de ses matchs à venir",
    competitionToBrowse: "Compétition à parcourir",
    popularCompetitions: "Compétitions populaires",
    loadingCompetitions: "Chargement des compétitions",
    backToCompetition: "Retour à la compétition",
    navAnalysisSection: "ANALYSE",
    sidebarTodayAnalysis: "Analyses du jour",
    sidebarLimitReached: "Limite atteinte • Passez à une formule supérieure",
    sidebarLeftToday: "{{count}} restante(s) aujourd'hui",
    sidebarNoPlan: "Aucune formule active"
}

export default frCommon
